<template>
<v-app>   
        <v-container align="left">
            <v-row>
                <v-col cols="12"> 
                       <v-dialog
                        v-model="espereDialog"
                        hide-overlay
                        persistent
                        width="300"
                    >
                        <v-card
                        color="primary"
                        dark
                        >
                        <v-card-text>
                            Por favor espere
                            <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                            ></v-progress-linear>
                        </v-card-text>
                        </v-card>
                    </v-dialog>
                    
                        <Paciente 
                            :infoUser="user"
                            :account_info_="account_info_local" 
                            @account_info_from_child="handlerDataSave">
                        </Paciente>

                  
                </v-col>
            </v-row>

                    <CitasPaciente
                    :dni="dni">
                    </CitasPaciente>
              
        </v-container>	
</v-app>
</template>

<script>

//import {initial_data} from "@/services/utils"
import {get_paciente} from "@/services/get"
import {update_paciente} from "@/services/create"
//import Leftmenu from '@/components/Leftmenu.vue'
import Paciente from "@/components/Paciente.vue"
import CitasPaciente from "@/components/CitasPaciente.vue"

export default {
    name: "Accounts",
    components: {
        Paciente,
        CitasPaciente
    },
    // Data
    data() {
        return {
            dni: '',
            account_id: "",
            authinfo: {
                    thalamus_server: this.$default_thalamus_server,
                    federation_acct: this.$store.state.credentials.fedacct,
                    password: this.$store.state.credentials.password,
                },
            account_info_local : {},
            account_info: {
                //mail:"",
                gender:"",
                name: "",
                lastname: "",
                //password: "" ,
                dni: "",
                roles: ["end_user"],
                dob: "",
                active: true,
                deceased: false,
                street:"",
                subdivision:"",
                insuranse:  "",
                telefono:"",
                city:"",
            },
            // local variables not to be passed
            user: false,
            mutual:"",
            genero:"",
            prov:"",
            pass_confirm: "",
            mail_confirm: "",
            info_paciente:"",
            goptions: [
                    { text: 'MASCULINO', value: 'm' },
                    { text: 'FEMENINO', value: 'f' }
                ],
            insuranseOptions: [],
            provincias:[],
            espereDialog: false,

        }
    },
    created(){    
        this.get_account(this.$route.params.idPaciente)

    },
    methods: {
        
       handlerDataSave: function (datos){
           this.espereDialog = true
           this.account_info = datos
           this.update_account()
       },
       async get_account (pacienteId) {
           
            //let datosAux=response.data;
            let dataResponse = await get_paciente(this.$store.state.credentials.thalamus_server, this.authinfo, pacienteId)
            let data =dataResponse[0];
            let direccion = dataResponse[1]
            let contacto = dataResponse[2]
            
            this.account_info.gender=data.party.gender
            this.account_info.mail=this.$store.state.credentials.fedacct
            this.account_info.dni=data.party.ref;
            this.account_info.name=data.party.name;
            this.account_info.lastname=data.party.lastname;
            this.account_info.password=this.$store.state.credentials.password;
            this.pass_confirm=this.$store.state.credentials.password
            this.mail_confirm=this.$store.state.credentials.fedacct
            this.account_info.dob=data.party.dob;
            if (data.seguro)
                this.account_info.insuranse=data.seguro.empresa.id;
           
            if (JSON.stringify(direccion)!='{}'){
                this.account_info.street=direccion.street;
                this.account_info.city=direccion.city;
                //this.provincias.value=direccion.provincia.id;
                if (direccion.provincia)
                    this.account_info.subdivision=direccion.provincia.id
            }
            if (JSON.stringify(contacto)!='{}'){
                this.account_info.telefono=contacto.value;
            }
            this.account_info_local = this.account_info
            this.dni = data.party.ref;
            
        },
 
        async update_account(){
            
            //this.account_info.mail=this.account_id
            let response = await update_paciente(this.$default_thalamus_server,this.authinfo,this.account_info)
            if (response==200){
                this.authinfo.federation_acct= this.account_info.mail
                this.authinfo.password= this.account_info.password
                this.authinfo.role = this.$store.state.credentials.role
                this.authinfo.name = this.account_info.name
                this.$store.commit('set_credentials', this.authinfo);
                alert("Actualizacion exitosa!");
            }else{
                alert("Hubo un problema al actualizar los datos!");
            }
            this.espereDialog = false

            /*await axios({
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'patch',
                url: this.$store.state.credentials.thalamus_server + "/person/" + this.$store.state.credentials.fedacct,
                auth: {
                    username: this.$store.state.credentials.fedacct,
                    password: this.$store.state.credentials.password
                },
                data: this.account_info,
            })
            .then(() => {
                
                
                
                }
            )
            .catch(e => { this.axios_errors.push(e)})
            //Update store
                this.authinfo.federation_acct= this.account_info.mail
                this.authinfo.password= this.account_info.password
                this.authinfo.role = this.$store.state.credentials.role
                this.authinfo.name = this.$store.state.credentials.name
                this.$store.commit('set_credentials', this.authinfo);
                alert("Actualizacion exitosa!");*/
        },
        

    },
}
</script>
<style>

  .style-select .vs__search::placeholder,
  .style-select .vs__dropdown-toggle,
  .style-select .vs__search,
  .style-select .vs__selected,
  .style-select .vs__dropdown-menu {
    background: #ffffff;
    border: none;
    text-transform: uppercase;
    font-variant: small-caps;
  }
  .vs__fade-enter-active,
  .vs__fade-leave-active {
        transition: none;
    }
</style>